import * as PriceGraphStyles from './PriceGraph.css';
import * as DayStyles from './components/Day/Day.css';
import * as MonthsListStyles from './components/MonthsList/MonthsList.css';
import * as LegendsStyles from './components/Legends/Legends.css';
import * as SliderStyles from './components/Slider/Slider.css';
export default {
    PriceGraphStyles,
    DayStyles,
    MonthsListStyles,
    LegendsStyles,
    SliderStyles
};
